/**
 * Sidebar navigation items for the Analytics module.
 * Provides navigation to analytics dashboard and reports with embedded Power BI.
 * Navigation items are feature-flag gated.
 */
import { Insights, InsightsOutlined } from '@mui/icons-material';

import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';

export interface AnalyticsNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const AnalyticsNavItems = (): AnalyticsNavItemsResult => {
  const navItems: NavItemType = {
    id: 'analytics',
    title: 'Analytics',
    type: 'collapse',
    icon: InsightsOutlined,
    iconSelected: Insights,
    url: '/analytics?module=analytics',
    featureFlag: FEATURE_FLAGS.ANALYTICS_MODULE_ENABLED,
    children: [
      {
        id: 'analytics_dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/analytics?module=analytics&submodule=analytics_dashboard',
        featureFlag: FEATURE_FLAGS.ANALYTICS_DASHBOARD_TAB
      },
      {
        id: 'reports',
        title: 'Reports',
        type: 'item',
        url: '/analytics?module=analytics&submodule=reports'
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default AnalyticsNavItems;
